/**
 * Self-compose 2×OneWay must be saved as two real LDS deals, never `SC-{out}-{in}`.
 */

export const SYNTHETIC_SELF_COMPOSE_PREFIX = "SC-";

export function isSyntheticSelfComposeDealId(dealId) {
  return String(dealId || "").trim().toUpperCase().startsWith(SYNTHETIC_SELF_COMPOSE_PREFIX);
}

export function stampLinkedFlightsLdsDealId(linkedFlights, dealId) {
  const lf =
    linkedFlights && typeof linkedFlights === "object" ? { ...linkedFlights } : null;
  if (!lf) return linkedFlights;
  const id = String(dealId ?? "").trim();
  if (id && !isSyntheticSelfComposeDealId(id) && !String(lf.ldsDealId || "").trim()) {
    lf.ldsDealId = id;
  }
  if (lf["@seqNum"] == null || lf["@seqNum"] === "") {
    lf["@seqNum"] = 1;
  }
  return lf;
}

function dealIdOf(deal) {
  const id = deal?.dealId ?? deal?.ID ?? deal?.id;
  return id != null ? String(id).trim() : "";
}

function supplierIdFromDeal(deal, linkedFlights) {
  const fromDeal =
    deal?.supplierId ||
    deal?.supplierDetails?.supplierId ||
    deal?.supplierDetails?.SupplierId;
  if (fromDeal) return fromDeal;
  const flight0 = linkedFlights?.flight?.[0];
  const leg = Array.isArray(flight0?.leg) ? flight0.leg[0] : flight0?.leg;
  return leg?.supplierId || "NONE";
}

/**
 * @returns {{ kind: "two_oneway", outbound: object, inbound: object } | { kind: "single", deal: object }}
 */
export function resolveSelfComposeLdsSaveDeals({ selectedFlightOffer, rawDeal }) {
  const out = selectedFlightOffer?.selfComposeLegs?.outboundRawDeal;
  const inn = selectedFlightOffer?.selfComposeLegs?.inboundRawDeal;
  const combined =
    selectedFlightOffer?.isSelfComposeCombined === true ||
    selectedFlightOffer?.source === "selfCompose" ||
    isSyntheticSelfComposeDealId(rawDeal?.dealId ?? rawDeal?.ID);
  if (combined && out && inn && dealIdOf(out) && dealIdOf(inn)) {
    return { kind: "two_oneway", outbound: out, inbound: inn };
  }
  return { kind: "single", deal: rawDeal };
}

export function buildFlightsNewLegFlightsInfo({
  agentId,
  persistComm,
  rawDeal,
  linkedFlights,
  passengersPayload,
  ldsSupplementPayload,
  ourPrice,
  extendedDealApiData,
  parseToLdsDate,
  getDepRetFromResult,
}) {
  const dealId = dealIdOf(rawDeal);
  const lf = stampLinkedFlightsLdsDealId(
    linkedFlights || rawDeal?.linkedFlights || rawDeal?.linkedflights,
    dealId
  );
  const { depDate, retDate } = getDepRetFromResult({
    ...(rawDeal && typeof rawDeal === "object" ? rawDeal : {}),
    linkedFlights: lf,
  });
  return {
    agent_id: agentId,
    later: "false",
    commission: persistComm.commission,
    handling_fee: persistComm.handling_fee,
    currency: "ILS",
    deal_id: dealId,
    deal_type: "Flights",
    supplierId: supplierIdFromDeal(rawDeal, lf),
    passengers_info: passengersPayload,
    ret_date: parseToLdsDate(retDate),
    dep_date: parseToLdsDate(depDate),
    supplement: ldsSupplementPayload,
    ourPrice,
    linkedFlights: lf,
    extended: extendedDealApiData,
  };
}
